import script from "./header.vue?vue&type=script&lang=ts&setup=true"
export * from "./header.vue?vue&type=script&lang=ts&setup=true"

import "./header.vue?vue&type=style&index=0&id=7573e122&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7573e122"]])

export default __exports__